import React from 'react'

import './styles.scss'
import './responsiveStyles.scss'
import { HIWVector2 } from '../../../../assets/svgs/landingV2/business'

function HowItWorks() {
  return (
    <div id='howitworks' className='bl_hiw'>
      <div className='bl_hiw__title'>
        <h1>Як це працює?</h1>
      </div>
      <div className='bl_hiw__info'>
        <div className='bl_hiw__info_column'>
          <div className='bl_hiw__info_block bl_hiw__info_block-first'>
            <div className='bl_hiw__info_block_title'>Крок 1</div>
            <div className='bl_hiw__info_block_text'>
              <p>Гість формує замовлення через застосунок Pinka. Кошти за замовлення блокуються.</p>
            </div>
          </div>
        </div>
        <div className='bl_hiw__info_column'>
          <div className='bl_hiw__info_block bl_hiw__info_block-second'>
            <div className='bl_hiw__info_block_title'>Крок 2</div>
            <div className='bl_hiw__info_block_text'>
              <p>Бариста отримує сповіщення в застосунок Pinka Barista та бере замовлення до виконання.</p>
            </div>
          </div>
        </div>
        <div className='bl_hiw__info_column'>
          <div className='bl_hiw__info_block bl_hiw__info_block-third'>
            <div className='bl_hiw__info_block_title'>Крок 3</div>
            <div className='bl_hiw__info_block_text'>
              <p>
                Гість отримує каву в закладі по номеру замовлення. Бариста позначає замовлення як виконане в застосунку
                Pinka Barista.
              </p>
            </div>
          </div>
        </div>
        <div className='bl_hiw__info_column'>
          <div className='bl_hiw__info_block bl_hiw__info_block-fourth'>
            <div className='bl_hiw__info_block_title'>Крок 4</div>
            <div className='bl_hiw__info_block_text'>
              <p>Гість насолоджується кавою. Кав&apos;ярня автоматично отримує кошти на банківський рахунок.</p>
            </div>
          </div>
        </div>
        <div className='bl_hiw__info_vector'>
          <img src={HIWVector2} />
        </div>
      </div>
    </div>
  )
}

export default HowItWorks
